export default __webpack_public_path__ + "static/media/visa-master-card.055ed10c.jpg";